import { surveySlice } from './slice';

export * from './async';
export * from './state';
export * from './folder';
export * from './survey';
export * from './addons/popup';

const Actions = surveySlice.actions;
const Reducer = surveySlice.reducer;

export { Reducer, Actions };
